var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("AprobarProgramacionJefeInmediato"),
      _vm._v(" "),
      _c("RechazarProgramacionJefeInmediato"),
      _vm._v(" "),
      _c("ValidarProgramacionJefeInmediato"),
      _vm._v(" "),
      _c("ValidarProgramacionJefeInmediatoPorFuncionario"),
      _vm._v(" "),
      _c("VerDetalleSolicitudes"),
      _vm._v(" "),
      _c("VerDetalleSolicitudesProgramacion"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("people")]),
          _vm._v("\n    Programación de vacaciones\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-text",
            [
              _c("strong", [_vm._v("DEPENDENCIA: ")]),
              _vm._v(
                _vm._s(this.$storage.get("user").unidad[0].nombre_unidad) +
                  "\n      "
              ),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v("AÑO DE PROGRAMACIÓN: ")]),
              _vm._v(_vm._s(this.$route.params.gestion) + "\n\n      "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            color: "rgba(156, 80, 162 ,0.3)",
                            disabled: !this.valida_programacion
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.validarProgramacionJefeInmediato()
                            }
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("done")
                          ]),
                          _vm._v("Validar programación dependencia\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Validar programaciones")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            color: "rgba(103,15,121,0.6)",
                            disabled: !this.aprueba_programacion
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.aprobarProgramacionJefeInmediato()
                            }
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("play_arrow")
                          ]),
                          _vm._v("Aprobar programación dependencia\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Enviar al jefe superior jerarquico")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return function() {
                                _vm.filterShow = true
                              }.apply(null, arguments)
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("filter_list")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Búsqueda/filtros")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.cargarProgramacionesGeneral()
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.filterShow
                ? _c(
                    "v-card",
                    { attrs: { color: "#eeffff" } },
                    [
                      _c(
                        "v-card-text",
                        { attrs: { id: "sin_margen2" } },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "v_card expandir",
                              attrs: { "grid-list-md": "" }
                            },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("h3", [_vm._v("Filtros")]),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { id: "sinMargen2", icon: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return function() {
                                            _vm.filterShow = false
                                            _vm.recargar()
                                          }.apply(null, arguments)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: "Servidor público",
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        on: { input: _vm.filterServidorPublico }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: "Fecha incorporación",
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        on: {
                                          input: _vm.filterFechaIncorporacion
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: "Saldo corte",
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        on: { input: _vm.filterSaldoCorte }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: "Dias asignados",
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        on: { input: _vm.filterDiasAsignados }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: "Total a programar",
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        on: { input: _vm.filterDiasProgramar }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_funcionarios_vacaciones,
                  "no-data-text": "Sin datos",
                  "item-key": "id",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  "no-results-text": "No se encontro coincidencias",
                  "rows-per-page-items": [
                    5,
                    10,
                    25,
                    { text: "Todos", value: -1 }
                  ],
                  "rows-per-page-text": "Filas por pagina",
                  "hide-actions": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "headerCell",
                    fn: function(props) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          { staticClass: "letra-cabecera" },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(props.header.text) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.header.text) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.servidor_publico))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_incorporacion)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_saldo_a))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_saldo_b))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_saldo_c))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.total_dias_saldo))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_programar))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_no_programados))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.ene != 0 ? items.item.ene : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.feb != 0 ? items.item.feb : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.mar != 0 ? items.item.mar : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.abr != 0 ? items.item.abr : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.may != 0 ? items.item.may : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.jun != 0 ? items.item.jun : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.jul != 0 ? items.item.jul : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.ago != 0 ? items.item.ago : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.sep != 0 ? items.item.sep : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.oct != 0 ? items.item.oct : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.nov != 0 ? items.item.nov : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.dic != 0 ? items.item.dic : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { attrs: { nowrap: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#0594A5",
                                  icon: "",
                                  title: "Ver detalle"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verDetalleProgramacion(
                                      items.item
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#6DE0BA",
                                  icon: "",
                                  title: "Descripción"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verDetalle(items.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("receipt")])],
                              1
                            ),
                            _vm._v(" "),
                            items.item.id_estado_vaca_progra == 51
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#FF5D34",
                                      icon: "",
                                      title: "Rechazar"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.rechazarProgramacionJefeInmediato(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("close")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_vaca_progra == 51
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#f1b3f6",
                                      icon: "",
                                      title: "Validar programación"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.validarProgramacionJefeInmediatoPorFuncionario(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("done")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f5b75b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5b75b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/VacacionAprobarJefe1.vue
// module id = null
// module chunks = 